// GetFTR Integrator entitlement indicators: lazy-loads as references enter the viewport.
var SCM = SCM || {};
SCM.SharedWidgets = SCM.SharedWidgets || {};

SCM.SharedWidgets.GetFtrEntitlements = (function ($) {

    var REF_LIST_SELECTOR = '.ref-list';
    var REF_ELEMENT_SELECTOR = '[data-content-id]';
    var DOI_SPAN_SELECTOR = 'span.inst-open-url-holders[data-targetId]';
    var DOI_PUBID_LINK_SELECTOR = 'a.link-pub-id-doi[href*="doi.org"]';
    var DOI_ELEMENT_SELECTOR = DOI_PUBID_LINK_SELECTOR + ', ' + DOI_SPAN_SELECTOR;
    var CITATION_LINKS_SELECTOR = 'div.citation-links, div.citation-links.inline';
    var CHECK_URL = '/GetFtrIntegrator/CheckEntitlements';

    // Class names are the single source of truth; the matching selectors are derived from them so the
    // injected markup and the lookups can't drift apart.
    var INDICATOR_CLASS = 'js-getftr-indicator';
    var INDICATOR_SELECTOR = '.' + INDICATOR_CLASS;
    var BUTTON_CLASS = 'js-getftr-button';
    var BUTTON_SELECTOR = '.' + BUTTON_CLASS;
    var LOADING_PLACEHOLDER_CLASS = 'js-getftr-loading';
    var LOADING_PLACEHOLDER_SELECTOR = '.' + LOADING_PLACEHOLDER_CLASS;
    // Deliberately not the theme's custom-tooltip-content class: that component removes every element
    // carrying it on window resize and rebuilds only its own, which would strip these panels and leave
    // their aria-describedby dangling. The panel is styled on its own class instead.
    var TOOLTIP_SELECTOR = '.getftr-tooltip';
    var TOOLTIP_VISIBLE_CLASS = 'getftr-tooltip--visible';

    // Suffix for unique tooltip ids so each button's aria-describedby resolves to its own tooltip,
    // including when Split View injects the same DOI into both panes.
    var tooltipCount = 0;

    // Chunk size comes from <meta name="getftr-max-dois"> emitted by _SiteMasterLayout so the
    // client batch stays in lock-step with the controller's IntegratorMaxDoisPerRequest cap.
    var DEFAULT_CHUNK_SIZE = 10;
    var CHUNK_SIZE = DEFAULT_CHUNK_SIZE;

    // Dedup across Split View clones (same DOI in both panes → one POST, two injections).
    var queuedDois = {};

    // DOI → ref elements, keyed lowercased so matching stays case-insensitive: the integrator
    // may echo a DOI in a different case than the markup.
    var refsByDoi = {};

    var observer = null;

    return {
        init: init
    };

    function init() {
        if (observer) {
            return;
        }

        if (!_featureIsOnPage()) {
            return;
        }

        if (typeof IntersectionObserver === 'undefined') {
            return;
        }

        CHUNK_SIZE = _readChunkSizeFromMeta();

        _bindIndicatorEvents();

        observer = new IntersectionObserver(_onIntersection, { rootMargin: '1000px 0px 1000px 0px' });

        $(REF_LIST_SELECTOR).each(function () {
            var refsWithDoi = $(this).find(REF_ELEMENT_SELECTOR).filter(function () {
                return $(this).find(DOI_ELEMENT_SELECTOR).length > 0;
            }).toArray();

            refsWithDoi.forEach(_indexRefByDoi);

            // Each chunk is stashed on its trigger (first ref) via __getftrChunk so _onIntersection
            // can batch the whole chunk's DOIs into one POST.
            for (var i = 0; i < refsWithDoi.length; i += CHUNK_SIZE) {
                var chunk = refsWithDoi.slice(i, i + CHUNK_SIZE);
                var trigger = chunk[0];
                trigger.__getftrChunk = chunk;
                observer.observe(trigger);
            }
        });
    }

    function _featureIsOnPage() {
        // The integrator meta is emitted by _SiteMasterLayout only when the feature is enabled.
        // Gating on it keeps init a no-op on the clients/pages where GetFTR is off, now that the
        // widget ships in the common bundle and loads on every page (articles, chapters, proceedings).
        if (!$('meta[name="getftr-integrator"]').length) {
            return false;
        }
        return $(REF_LIST_SELECTOR).find(DOI_ELEMENT_SELECTOR).length > 0;
    }

    function _readChunkSizeFromMeta() {
        var raw = $('meta[name="getftr-max-dois"]').attr('content');
        var parsed = parseInt(raw, 10);
        if (isNaN(parsed) || parsed <= 0) {
            return DEFAULT_CHUNK_SIZE;
        }
        return parsed;
    }

    function _onIntersection(entries, observerInstance) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
                return;
            }
            observerInstance.unobserve(entry.target);

            var chunk = entry.target.__getftrChunk || [entry.target];
            var dois = [];
            chunk.forEach(function (ref) {
                var doi = _extractDoi($(ref));
                if (!doi || queuedDois[doi]) {
                    return;
                }
                queuedDois[doi] = true;
                dois.push(doi);
            });

            if (!dois.length) {
                // All DOIs in this chunk were already queued by a Split View clone — nothing to do.
                return;
            }

            _postBatch(dois);
        });
    }

    function _indexRefByDoi(ref) {
        var doi = _extractDoi($(ref));
        if (!doi) {
            return;
        }
        var key = _doiKey(doi);
        if (!refsByDoi[key]) {
            refsByDoi[key] = [];
        }
        refsByDoi[key].push(ref);
    }

    function _extractDoi($ref) {
        // Prefer the inline article-level pub-id DOI over the inst-open-url-holders span DOI.
        // Some publishers (e.g. Wiley) put a volume-level DOI in the crossrefdoi element
        // (which drives the span) while the article DOI is in a pub-id element rendered as
        // an inline link. Querying the volume DOI against GetFTR returns no entitlements;
        // querying the article DOI correctly returns OA/entitled status.
        var $pubIdLink = $ref.find(DOI_PUBID_LINK_SELECTOR).first();
        if ($pubIdLink.length) {
            var href = $pubIdLink.attr('href');
            var match = href && href.match(/doi\.org\/(.+)/);
            if (match && match[1]) {
                return decodeURIComponent(match[1]);
            }
        }
        var $span = $ref.find(DOI_SPAN_SELECTOR).first();
        if (!$span.length) {
            return null;
        }
        var raw = $span.attr('data-targetId');
        if (!raw) {
            return null;
        }
        // data-targetId is URL-encoded ('/' → '%2F'). decodeURIComponent gives us the canonical DOI.
        return decodeURIComponent(raw);
    }

    function _doiKey(doi) {
        return doi.toLowerCase();
    }

    function _postBatch(dois) {
        // __RequestVerificationToken is emitted by the layout only when the integrator is enabled;
        // [ValidateAntiForgeryToken] on the server consumes it.
        var token = $('input[name="__RequestVerificationToken"]').val();
        if (!token) {
            return;
        }

        _showLoadingPlaceholders(dois);

        SCM.Ajax.post(CHECK_URL, {
            Dois: dois,
            __RequestVerificationToken: token
        })
            .expectJson()
            .then(function (result) {
                _removeLoadingPlaceholders(dois);
                if (!result || !result.IndicatorsByDoi) {
                    return;
                }
                Object.keys(result.IndicatorsByDoi).forEach(function (doi) {
                    _injectIndicators(doi, result.IndicatorsByDoi[doi]);
                });
            })
            .catch(function () {
                // Progressive enhancement: on failure, drop the spinners and show no indicators.
                _removeLoadingPlaceholders(dois);
            });
    }

    function _showLoadingPlaceholders(dois) {
        dois.forEach(function (doi) {
            _citationLinksForDoi(doi).forEach(function ($citationLinks) {
                if ($citationLinks.find(LOADING_PLACEHOLDER_SELECTOR).length || $citationLinks.find(INDICATOR_SELECTOR).length) {
                    return;
                }
                $citationLinks.prepend(_buildLoadingPlaceholder());
            });
        });
    }

    function _removeLoadingPlaceholders(dois) {
        dois.forEach(function (doi) {
            _citationLinksForDoi(doi).forEach(function ($citationLinks) {
                $citationLinks.find(LOADING_PLACEHOLDER_SELECTOR).remove();
            });
        });
    }

    function _injectIndicators(doi, indicators) {
        if (!indicators || !indicators.length) {
            return;
        }

        _citationLinksForDoi(doi).forEach(function ($citationLinks) {
            if ($citationLinks.find(INDICATOR_SELECTOR).length) {
                return;
            }

            // GetFTR buttons display before the other reference links (Scenario 1, SCMP-37909); one joined
            // prepend keeps the server's indicator order (access, retraction, updates).
            var markup = indicators.map(_buildIndicator).join('');
            $citationLinks.prepend(markup);
        });
    }

    function _citationLinksForDoi(doi) {
        var matchingRefs = refsByDoi[_doiKey(doi)];
        if (!matchingRefs || !matchingRefs.length) {
            return [];
        }

        var citationLinks = [];
        matchingRefs.forEach(function (ref) {
            var $citationLinks = $(ref).find(CITATION_LINKS_SELECTOR).first();
            if ($citationLinks.length) {
                citationLinks.push($citationLinks);
            }
        });
        return citationLinks;
    }

    function _buildLoadingPlaceholder() {
        return '<span class="' + LOADING_PLACEHOLDER_CLASS + ' getftr-indicator getftr-indicator--loading" aria-hidden="true"></span>';
    }

    // aria-describedby flattens what it points at, so a link inside would be announced but
    // unreachable: panels without a link are role="tooltip"; the licence panel is a popover whose
    // aria-describedby points at the text span only, leaving the link tabbable.
    function _buildIndicator(indicator) {
        var tooltip = indicator.Tooltip;
        if (!tooltip || !tooltip.Text) {
            return _buildIndicatorMarkup(indicator, '', '');
        }

        tooltipCount++;
        var panelId = 'getftr-tooltip-' + tooltipCount;
        var hasLink = !!(tooltip.LinkLabel && tooltip.LinkUrl);
        var textId = panelId + '-text';

        return _buildIndicatorMarkup(
            indicator,
            _buildPanel(panelId, textId, tooltip, hasLink),
            ' aria-describedby="' + (hasLink ? textId : panelId) + '"');
    }

    function _buildIndicatorMarkup(indicator, panelHtml, describedByAttr) {
        return '<span class="' + INDICATOR_CLASS + ' getftr-indicator-wrap">' +
            '<button type="button" class="' + BUTTON_CLASS + ' getftr-indicator" data-getftr-kind="' + _escape(indicator.Kind) +
            '" data-getftr-url="' + _escape(indicator.Url) + '"' + describedByAttr + '>' +
            '<span class="getftr-indicator__icon" aria-hidden="true"></span>' +
            _escape(indicator.Label) +
            '</button>' +
            panelHtml +
            '</span>';
    }

    function _buildPanel(panelId, textId, tooltip, hasLink) {
        var body = '<span class="getftr-tooltip__text" id="' + textId + '">' +
            _escape(tooltip.Text).replace(/\n/g, '<br>') +
            '</span>';

        if (tooltip.Reasons && tooltip.Reasons.length) {
            body += '<ul class="getftr-tooltip__reasons">' +
                tooltip.Reasons.map(function (reason) {
                    return '<li class="getftr-tooltip__reason">' + _escape(reason) + '</li>';
                }).join('') +
                '</ul>';
        }

        if (tooltip.FooterText) {
            body += '<span class="getftr-tooltip__footer">' + _escape(tooltip.FooterText) + '</span>';
        }

        if (hasLink) {
            body += '<a class="getftr-tooltip__link" href="' + _escape(tooltip.LinkUrl) +
                '" target="_blank" rel="noopener">' + _escape(tooltip.LinkLabel) + '</a>';
        }

        // role="tooltip" only where the panel holds no interactive content.
        var roleAttr = hasLink ? '' : ' role="tooltip"';
        return '<span class="getftr-tooltip" id="' + panelId + '"' + roleAttr + '>' +
            body +
            '</span>';
    }

    function _bindIndicatorEvents() {
        $(document).on('click', BUTTON_SELECTOR, _onButtonClick);

        // The wrapper (button + panel) drives visibility, so the panel stays open while hovered and
        // while its license link holds keyboard focus (WCAG 1.4.13 hoverable content).
        $(document).on('mouseenter focusin', INDICATOR_SELECTOR, _onIndicatorEnter);
        $(document).on('mouseleave focusout', INDICATOR_SELECTOR, _onIndicatorLeave);
        $(document).on('keydown', INDICATOR_SELECTOR, _onIndicatorKeydown);
        $(document).on('click', _onDocumentTouchClick);
    }

    // Without hover there is no way to read the panel, and its license link would be unreachable, so
    // on touch the first tap opens the panel and a second tap follows the button through.
    function _onButtonClick(e) {
        var $button = $(e.currentTarget);
        var $panel = $button.siblings(TOOLTIP_SELECTOR);

        if (_isTouchOnly() && $panel.length && !$panel.hasClass(TOOLTIP_VISIBLE_CLASS)) {
            _closeAllPanels();
            $panel.addClass(TOOLTIP_VISIBLE_CLASS);
            return;
        }

        var url = $button.attr('data-getftr-url');
        if (url) {
            window.open(url, '_blank', 'noopener');
        }
    }

    function _isTouchOnly() {
        return window.matchMedia && window.matchMedia('(hover: none)').matches;
    }

    function _closeAllPanels() {
        $(TOOLTIP_SELECTOR).removeClass(TOOLTIP_VISIBLE_CLASS);
    }

    function _onDocumentTouchClick(e) {
        if (!_isTouchOnly()) {
            return;
        }
        if (!$(e.target).closest(INDICATOR_SELECTOR).length) {
            _closeAllPanels();
        }
    }

    function _onIndicatorEnter(e) {
        $(e.currentTarget).find(TOOLTIP_SELECTOR).addClass(TOOLTIP_VISIBLE_CLASS);
    }

    function _onIndicatorLeave(e) {
        // focusout fires as focus moves from the button to the license link inside the same panel.
        // Hiding on that would set display:none on the ancestor of the element about to take focus and
        // strand the link, so keep the panel open while focus stays within the wrapper.
        if (e.relatedTarget && $.contains(e.currentTarget, e.relatedTarget)) {
            return;
        }
        $(e.currentTarget).find(TOOLTIP_SELECTOR).removeClass(TOOLTIP_VISIBLE_CLASS);
    }

    function _onIndicatorKeydown(e) {
        if (e.key === 'Escape') {
            $(e.currentTarget).find(TOOLTIP_SELECTOR).removeClass(TOOLTIP_VISIBLE_CLASS);
        }
    }

    function _escape(s) {
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

})(jQuery);
